import React from 'react';
import { DEFAULT_ROUTING_DATA, RoutingData, RoutingDataContext } from './context';

const RoutingDataProvider: React.FC<React.PropsWithChildren<Record<never, unknown>>> = ({ children }) => {
  const [routingData, setRoutingData] = React.useState<RoutingData>(DEFAULT_ROUTING_DATA);

  return (
    <RoutingDataContext.Provider value={{ routingData, setRoutingData }}>
      {children}
    </RoutingDataContext.Provider>
  );
};

export default RoutingDataProvider;
